define ['./sendApplicationLink.scss'], () ->
  ($state, RENTAPPLICATION_API_URL, HOST, $uibModal, $cacheFactory) ->
    restrict: "E"
    template: require('./sendApplicationLink.jade')
    scope:
      apptemp: '='
    link: (scope, element, attrs) ->
      scope.success_svg = require('./sendApplicationLinkModal/form-sent-illustration.svg')

      scope.open_modal = () ->
        $uibModal.open
          scope: scope
          controller: require('./sendApplicationLinkModal/sendApplicationLinkModal.coffee')
          template: require("./sendApplicationLinkModal/sendApplicationLinkModal.jade")
          windowClass: 'send-application-link'
        .result.then (email_content) ->
          $cacheFactory.get('$http').removeAll()
          scope.email_content = email_content

          $uibModal.open
            scope: scope
            template: require("./sendApplicationLinkModal/sendApplicationLinkSuccessModal.jade")
            windowClass: 'send-application-success'





// WEBPACK FOOTER //
// ./directives/sendApplicationLink/sendApplicationLink.coffee